import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { NicaDataGridComponent } from '../../../components/nica-data-grid/nica-data-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from '../../../services/api.service';
import { HttpClient } from '@angular/common/http';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { ComponentService } from '../../../services/component.service';
import { AnaColumn, FormsTemplateService } from '../../../services/forms-template.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { RentriService } from '../../../services/rentri.service';
import { alert, confirm } from 'devextreme/ui/dialog';
import { formatNumber } from '@angular/common';




@Component({
  selector: 'app-gestione-rintracciabilita-rifiuti',
  templateUrl: './gestione-rintracciabilita-rifiuti.component.html',
  styleUrls: ['./gestione-rintracciabilita-rifiuti.component.css']
})
export class GestioneRintracciabilitaRifiutiComponent extends NicaMaster implements OnInit, AfterViewInit {



  @ViewChild('dataGrid', { static: false }) nicaDataGrid: NicaDataGridComponent

  
  @Input() itemData: any;

  @Input() isAttivaRintracciabilita;
  @Input() caricoDaMiscelazione;
  @Input() listaHP;
  @Input() quantita;
  @Input() idMovimento;
  @Input() dataRegistrazione;
  @Input() title;
  @Input() formData;

  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  showGrid: boolean = false;
  dataSourceRintracciabilita: any = [];
  colonneGrigliaRintracciabilita: AnaColumn[] = []
  toolbarButtonsTop:any[] = []
  constructor(
    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,

    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );

  }

  ngAfterViewInit(): void {
    // this.nicaDataGrid.startAllEditor();
  }

  ngOnInit() {
    //this.colonneGrigliaRintracciabilita = this.formTemplateService.getService('RintraccMiscelazione')
    this.showToolBar = false;

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.titleDynamic = this.itemData[0].title;
      let formData = this.itemData[0].data
      this.rowData['idSede'] = formData.idLotto_Sede;
      this.rowData['idPosizioneRifiuto'] = formData.idPosizioneRifiuto;

      //console.log('itemData-->', this.rowData)

    } else {
      this.activatedroute.queryParams
        .subscribe(params => {

          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName

          this.setGlobalVariableFromParams(params);
          this.titleDynamic = this.itemData[0].title;
          let formData = this.itemData[0].data
          this.rowData['idSede'] = formData.idLotto_Sede;
          this.rowData['idPosizioneRifiuto'] = formData.idPosizioneRifiuto;
        });
    }

    this.setViewRintracciabilita()

  }
  async setViewRintracciabilita() {
    

    

    if(this.rowData.length==0){

      this.filterID['isAttivaRintracciabilita']=this.isAttivaRintracciabilita,
      this.filterID['caricoDaMiscelazione']= this.caricoDaMiscelazione,
      this.filterID['listaHP'] =  this.listaHP;
      this.filterID['quantita']= this.quantita;
      this.filterID['idMovimento']= this.idMovimento;
      this.filterID['dataRegistrazione']= this.dataRegistrazione;
      this.filterID['idMovimento'] = this.idMovimento;

      this.titleDynamic = this.title;
      
      this.rowData['idSede'] = this.formData.idLotto_Sede;
      this.rowData['idPosizioneRifiuto'] = this.formData.idPosizioneRifiuto;
    }

    await this.getDataSource();


  }

  async getDataSource() {

    let inData = this.filterID
    const IdMovimento = inData['idMovimento'];
    const DataRegistrazione = inData['dataRegistrazione'];
   
    const APISET = 'MovimentoRifiuti/GetListaTracciabilita';

    let queryParams = `?IdMovimento=${IdMovimento}&DataRegistrazione=${DataRegistrazione}`;

   
    const peso = formatNumber(Number(this.quantita), 'it-IT', '1.0-3');
    let pesoMovimento = 'Totale Peso scaricato(Kg): ' + peso
    this.toolbarButtonsTop=[
      {
        id: 'textPeso',
        text: pesoMovimento,
        icon: null,
        disabled: false,
        image:null ,
        separator: null,
        visible: true,
        hint: '',
        name: 'peso',
        position:'left',
        widget: 'textDesc'
      }
    ]
  

    return this.anagraficaService.getElenco(APISET, '', queryParams).then(ress => {

      if (ress['items']) {
        ress = ress['items']

      }

      this.dataSourceRintracciabilita = ress



      this.showGrid = true;
    })

  }


  gridEventRintracciabilita() {

  }
  gridEventCellValue(event) {


    if (event.name == 'cellValueChange') {
      let dataCellEdit = this.nicaDataGrid.editorCellByRow;

      let colsHeader = this.nicaDataGrid.colsHeader;
      let rowIndex = event.rowIndex;
      let rowData = event.rowData;
      let value = event.value;
      if (event.cellName == "lega") {
        if (value) {
          if (rowData.legaChiudi) {
            rowData.legaChiudi = false
            this.dataSourceRintracciabilita[rowIndex].legaChiudi = false
            this.nicaDataGrid.editorData[rowIndex]['data'].legaChiudi = false
          }

        }
      }

      if (event.cellName == "legaChiudi") {
        if (value) {
          if (rowData.lega) {
            this.dataSourceRintracciabilita[rowIndex].lega = false
            this.nicaDataGrid.editorData[rowIndex]['data'].lega = false
          }

        }
      }

      if (event.cellName == "quantita") {

        let value = event.value;
        if (value) {
          
          let quantitaTrattata = rowData.quantitaTrattata;

          let calcPerc = Math.floor((value / quantitaTrattata) * 100).toFixed(2)
          this.dataSourceRintracciabilita[rowIndex].percentuale = calcPerc;
          this.nicaDataGrid.editorData[rowIndex]['data'].percentuale = calcPerc
          let col = this.nicaDataGrid.editorData[rowIndex]['colProp']['quantita']
          this.nicaDataGrid.calcolaSomma(col)
          //this.dataSourceRintracciabilita[rowIndex]['riferimentoEER']='pipppppppp'
          /* let col = this.nicaDataGrid.editorData[rowIndex]['colProp']['quantita']
          this.nicaDataGrid.calcolaSomma(col) */
        }

      }
 
    }
  }

  rispostaBottoni(ev) {

    switch (ev) {


      case 16:


        let datatoSendOutput = {
          name: 'returnMov',
          listaTracciabilita: null
        }
        this.outputEmit.emit(datatoSendOutput);




        break;
      case 0:

        confirm("Abbandonando, eventuali modifiche non verranno salvate, confermi l'abbandono ed il salvataggio del movimento di carico?", 'Attenzione!').then(confirmRes => {

          if (confirmRes) {

            let datatoSendOutput = {
              name: 'return',
              listaTracciabilita: null
            }
            this.outputEmit.emit(datatoSendOutput);
          }
        })



        break;
      case 15:

        this.convalidDataGrid()


        break;

    }
  }
  convalidDataGrid() {

    //let checkValidation = true

    const dataB = this.nicaDataGrid.saveEditorDataInbatch();

    let lista = []

    dataB.map(res => {

      if (res.quantita) {
        lista.push(res)
      }

    })

    if (dataB.length > 0) {
      let quantitaKgMovimento = this.filterID['quantita'];

      let rows = this.nicaDataGrid.righe.map(row => {
        let ro = row.nativeElement

        if (ro.classList.contains('error-row')) {
          ro.classList.remove('error-row')
        }

        return ro;
      })

      const APISETC = 'MovimentoRifiuti/ConvalidaListaTraciabilita?QuantitaKg=' + quantitaKgMovimento;

      this.nicaDataGrid.rowSelected = [false];
      this.anagraficaService.actionPut(APISETC, this.dataSourceRintracciabilita, false).then(ress => {
        let messages = ''
        if (ress != '') {
          ;
          for (let x in ress) {

            if (ress[x].id < 0) {
              messages += '<p>' + ress[x].descrizione + '</p>';
              alert(messages, 'Attenzione!')
              return

            }

            messages += '<p>' + ress[x].descrizione + '</p>';
            rows[ress[x].id].classList.add('error-row')
            this.nicaDataGrid.rowSelected[ress[x].id] = true;
          }

          alert(messages, 'Attenzione!')
          return
        } else {
          let datatoSendOutputSave = {
            name: 'saveData',
            data: lista
          }

          this.outputEmit.emit(datatoSendOutputSave);
        }

      })
    }


    /*forEach((editorDataR, index) => {
       if (editorDataR.edit) {
         this.nicaDataGrid.saveEditorData(index, null).then(res=>{
           let checkValidation =res.currentData
 
           console.log('checkValidation',checkValidation);
         })
 
        
         //checkValidation = false
         //return 
       }
     })
 
     console.log('dataSourceRintracciabilita-->', this.dataSourceRintracciabilita)
     /* if(!checkValidation){
      return 
     }
      const APISET = 'MovimentoRifiuti/ConvalidaListaSchedeLavorazioni?IdPosizioneRifiutoMovimentoDiScarico=' + this.rowData['idPosizioneRifiuto'];
  
      let rows = this.nicaDataGrid.righe.map(row=>{
        return row.nativeElement
      })
  
      this.nicaDataGrid.rowSelected = [false];
      this.anagraficaService.actionPut(APISET,this.dataSourceLavorazioni,false).then(ress => {
        let messages = ''
        if(ress != ''){
           ress;
          for(let x in ress){
            messages += '<p>' + ress[x].descrizione + '</p>';
            rows[ress[x].id].classList.add('error-row')
            this.nicaDataGrid.rowSelected[ress[x].id] = true;
          }
          
          alert(messages,'Attenzione!')
          
        }else{
           let datatoSendOutputSave = {
            name: 'saveData',
            data: this.dataSourceLavorazioni
          }
  
          this.outputEmit.emit(datatoSendOutputSave)
          console.log('dataSourceLavorazioni-->', this.dataSourceLavorazioni)
        }
  
      }) */
  }
}